
<script>
import { h, ref, onMounted } from 'vue'

export default {
    props: {
        root: String
    },

    setup(props, { slots, attrs, emit }) {
        const isActive = ref(false)

        onMounted(() => {
            setTimeout(() => {
                isActive.value = true;
            }, 500)
        })

        return () =>
        h(
            props.root,
            {
                class: [props.class, {'active': isActive.value}],
            },
            slots.default()
        )
    }
}
</script>